import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";
import Icon from "@/src/components/Icon/Icon";

export default function MessageCenterNoCasesMessage() {
  return (
    <ContentBox>
      <Stack sx={{ alignItems: "center", textAlign: "center", marginTop: "3rem" }}>
        <Icon icon={({ fill }) => <InfoOutlined sx={{ fill }} />} variant={"bordered"} />
        <Typography variant={"h7"} component={"h2"} sx={{ marginTop: "1rem" }}>
          Noch kein Fall vorhanden
        </Typography>
        <Typography sx={{ marginTop: "1rem", marginLeft: "1rem", marginRight: "1rem" }}>
          Sobald Sie einen Fall bei uns haben, können Sie von hier aus ganz bequem direkt mit Ihrem Anwalt kommunizieren. Sie haben vorab z.B. eine Frage zum
          Ablauf? Dann schreiben Sie uns eine E-Mail an{" "}
          <a href={"mailto:service@legalbird.de"}>
            <b>service@legalbird.de</b>
          </a>
        </Typography>
        <Button variant={"contained"} href={"mailto:service@legalbird.de"} sx={{ alignSelf: { xs: "stretch", sm: "flex-end" }, marginTop: "2rem" }}>
          Neue Nachricht senden
        </Button>
      </Stack>
    </ContentBox>
  );
}
